<template> 
	<div class="whitebox company-tags	centerpage " v-show="hasdata">
		<div class=" d_blocktitle d-floortitle">
			<i class="title-icon title-icon3"></i>
			<h3 class="title">{{title}}</h3>
		</div>  
		<div class="riskInformation w95mg mb-3 locktable" v-if="hasdata">
			<p class="mb3 orangefont">
				<span :key="i" v-for="(text,i) in riskText" >{{text}}{{i == riskText.length-1 ? '' : ';'}}</span> 
			</p>
			<div class="risktab oh">
				<span :class="risktype == item.type ? 'fl current':'fl'" @click="risktype = item.type" v-show="item.noempty" :key="index" v-for="(item,index) in riskname">{{item.name}}</span>
			<!-- 	<span :class="risktype == 1 ? 'fl current':'fl'" @click="risktype = 1" v-show="blockdata.executedPerson.length>0">被执行人</span> 
				<span :class="risktype == 2 ? 'fl current':'fl'" @click="risktype = 2" v-show="blockdata.judgmentDoc.length>0">裁判文书</span> 
				<span :class="risktype == 3 ? 'fl current':'fl'" @click="risktype = 3" v-show="blockdata.breakPromise.length>0">失信信息</span> 
				<span :class="risktype == 4 ? 'fl current':'fl'" @click="risktype = 4" v-show="blockdata.judicialCase.length>0">司法案件</span> 
				<span :class="risktype == 5 ? 'fl current':'fl'" @click="risktype = 5" v-show="blockdata.limitExpense.length>0">限制高消费</span> -->
			</div>
			<!--  executedPerson（被执行人）  judgmentDoc（裁判文书） breakPromise（失信信息） judicialCase（司法案件） limitExpense（限制高消费）  -->
		<!-- 被执行人 -->
			<table border="0" cellspacing="0" cellpadding="0" v-show="risktype == 1" class="pagetable1">
				<tr>   
					<th class="xuhaotd">序号</th>
					<th>案号</th>
					<th>证件号/组织机构代码</th>
					<th>疑似申请执行人</th>
					<th>立案日期</th> 
					<th>执行法院</th>
					<th>执行标的（元）</th>
				</tr>
				<tr :key="i" v-for="(list,i) in executedPerson" v-if="i<executeNum">
					<td>{{i+1}}</td>
					<td>{{list.caseNo}}</td>
					<td>{{list.certificateNo}}</td>
					<td>{{list.applicant}}</td>
					<td>{{list.regDate}}</td>
					<td>{{list.execCourt}}</td>
					<td>{{list.execSubject}}</td>
				</tr>
			</table>
			<freeUserTips :type="1" v-if="executedPerson.length>2 && isFree" :bgtype="10" v-show="risktype == 1"></freeUserTips>
		<!-- 裁判文书 -->
			<table border="0" cellspacing="0" cellpadding="0" v-show="risktype == 2" class="pagetable1">
				<tr >    
					<th class="xuhaotd">序号{{judgmentNum}}</th>
					<th>文书标题</th>
					<th>案由</th>
					<th>案号</th>
					<th>当事人</th>
					<th>案件金额（元）</th>
					<th>裁判结果</th>
					<th>发布日期</th>
					<th>裁判日期</th>
					<th>法院名称</th>
				</tr>
				<tr :key="i" v-for="(list,i) in judgmentDocNew" v-if="i<judgmentNum">
					<td>{{i+1}}</td>
					<td>{{list.title}}</td>
					<td>{{list.caseOfAction}}</td>
					<td>{{list.caseNo}}</td>
					<td class="tal"> 
					{{list.person}}
					<!-- <p :class="list.personshowAll?'':'shortfont_box'">{{list.person}}</p>
					<span class="dispaybtn1" v-show="!list.personshowAll"  @click="list.personshowAll=!list.personshowAll">展开 </span> -->
					</td>
					<td>{{list.caseAmount}}</td>
					<td class="tal">
						<p :class="list.judeshowAll?'':'shortfont_box'">{{list.judgResult}}</p>
						<span class="dispaybtn1" v-show="!list.judeshowAll"  @click="list.judeshowAll=!list.judeshowAll">展开 </span>
					</td>
					<td>{{list.publishDate}}</td>
					<td>{{list.judgDate}}</td>
					<td>{{list.courtName}}</td>
				</tr>
			</table>
				<freeUserTips :type="1" v-if="judgmentDocNew.length>2 && isFree" :bgtype="11" v-show="risktype == 2"></freeUserTips>
				<!-- 失信信息 -->
			<table border="0" cellspacing="0" cellpadding="0" v-show="risktype == 3" class="pagetable1">
				<tr>    
					<th class="xuhaotd">序号</th>
					<th>案号</th>
					<th>疑似申请执行人</th>
					<th>执行法院</th>
					<th>执行依据文号</th> 
					<th>履行情况</th> 
					<th>失信行为</th> 
					<th>涉案金额（元）</th> 
					<th>立案日期</th> 
					<th>发布日期</th> 
				</tr>
				<tr :key="i" v-for="(list,i) in breakPromise" v-if="i<breakPromiseNum">
					<td>{{i+1}}</td>
					<td>{{list.caseNo}}</td>
					<td>{{list.applicant}}</td>
					<td>{{list.execCourt}}</td>
					<td>{{list.execNo}}</td>
					<td>{{list.implementation}}</td>
					<td>{{list.dishonestBehavior}}</td>
					<td>{{list.caseAmount}}</td>
					<td>{{list.regDate}}</td>
					<td>{{list.publishDate}}</td>
				</tr>
			</table>
			<freeUserTips :type="1" v-if="breakPromise.length>2 && isFree" :bgtype="12" v-show="risktype == 3"></freeUserTips>
			<!--司法案件  -->
			<table border="0" cellspacing="0" cellpadding="0" v-show="risktype == 4" class="pagetable1">
				<tr > 
					<th class="xuhaotd">序号</th>
					<th>案件名称</th>
					<th>案件类型</th>
					<th>案件身份</th>
					<th>案由</th>
					<th>案号</th>
					<th>案件金额（元）</th>
					<th>法院</th>
					<th>最新审理程序</th>
					<th>最新进程日期</th>
				</tr>
				<tr :key="i" v-for="(list,i) in judicialCase" v-if="i<judicialCaseNum">
					<td>{{i+1}}</td>
					<td>{{list.title}}</td>
					<td>{{list.caseType}}</td>
					<td>{{list.caseStatus}}</td>
					<td>{{list.caseCause}}</td>
					<td>{{list.caseNo}}</td>
					<td>{{list.amount}}</td>
					<td>{{list.courtName}}</td>
					<td>{{list.latestProcedure}}</td>
					<td>{{list.latestProgressDate}}</td>
				</tr>
			</table>
			<freeUserTips :type="1" v-if="judicialCase.length>2 && isFree"  :bgtype="13" v-show="risktype == 4"></freeUserTips>
			<!-- 限制高消费 -->
			<table border="0" cellspacing="0" cellpadding="0" v-show="risktype == 5" class="pagetable1">
				<tr>
					<th class="xuhaotd">序号</th> 
					<th>案号</th>
					<th>限消令对象</th>
					<th>关联对象</th>
					<th>申请人</th>
					<th>法院</th>
					<th>立案日期</th>
					<th>发布日期</th>
				</tr>
				<tr :key="i" v-for="(list,i) in limitExpense"  v-if="i<limitExpenseNum">
					<td>{{i+1}}</td>
					<td>{{list.caseNo}}</td>
					<td>{{list.limitObject}}</td>
					<td>{{list.relatedObject}}</td>
					<td>{{list.applicant}}</td>
					<td>{{list.courtName}}</td>
					<td>{{list.regDate}}</td>
					<td>{{list.publishDate}}</td>
				</tr>
			</table>
			<freeUserTips :type="1" v-if="limitExpense.length>2 && isFree" :bgtype="14" v-show="risktype == 5"></freeUserTips> 
		</div> 
	</div> 
</template>

<script>
	import freeUserTips from "@/components/enterpriseInc/free-user-tips.vue"
	export default {
	  name: 'riskInformation', 
			data() {
				return {
					riskText:[],
					risktype:9,riskname:[
						{type:1,name:"被执行人",list:[],noempty:false,},
						{type:2,name:"裁判文书",list:[],noempty:false,},
						{type:3,name:"失信信息",list:[],noempty:false,},
						{type:4,name:"司法案件",list:[],noempty:false,},
						{type:5,name:"限制高消费",list:[],noempty:false,},],
					riskdata:[],docFlag:false,judgmentDocNew:[],
					testbtnlist:[{caseAmount: "-",judeshowAll:false,
     caseNo: "（2021）闽0902民初3840号",
     caseOfAction: "保险人代位求偿权纠纷",
     courtName: "宁德市蕉城区人民法院",
     id: 51374,
     judgDate: "2022-08-08",
					judgResult: "驳回中国人民财产保险股份有限公司宁德市分公司的诉讼请求。",
     person: "原告-中国人民财产保险股份有限公司宁德市分公司 \n代理律师事务所-福建观松律师事务所 \n被告-茂荣集团股份有限公司宁德分公司 \n代理律师事务所-福建凡圃律师事务所 \n第三人-宁德时代新能源科技股份有限公司",
					publishDate: "2023-03-02",
     title: "保险人代位求偿权纠纷民事一审判决书"}],
					executeNum:1,
					judgmentNum:1,
					breakPromiseNum:1,
					judicialCaseNum:1,
					limitExpenseNum:1,
			}},
	  props: { 
					title: String,hasdata:Boolean,
					executedPerson:Array,
					judgmentDoc:Array,
					breakPromise:Array,
					judicialCase:Array,
					limitExpense:Array,
					isFree:{type:Boolean,default:false,},
					// blockdata:{
					// 	type:Object,default:true
					// },
	  }, 
			components:{
				freeUserTips
			},
			created() {
				
				// if(this.executedPerson.length>0){
				// 		this.risktype=1;
				// }else if(this.judgmentDoc.length>0){
				// 		this.risktype=2
				// }else if(this.breakPromise.length>0){
				// 		this.risktype=3
				// }else if(this.judicialCase.length>0){
				// 		this.risktype=4
				// }else if (this.limitExpense.length>0){
				// 		this.risktype=5
				// }
				
				if(this.executedPerson.length>0){ 
						this.riskname[0].noempty=true;
				}else{
						this.riskText.push('暂无被执行人风险');
				}
				if(this.judgmentDoc.length>0){ 
						this.riskname[1].noempty=true;
						// console.log('aaa',this.judgmentDoc)
						//为了隐藏裁判文书中的裁判结果过长文字，决定将参数名字写死保存 后期有问题可以删除 该功能会时效
						var arrlist=[]; 
						for(var i=0;i<this.judgmentDoc.length;i++){
							let data=this.judgmentDoc[i];
							let smlist={
								caseAmount: data.caseAmount, 
						  caseNo: data.caseNo,
						  caseOfAction:data.caseOfAction,
						  courtName:data.courtName,
						  id:data.id,
						  judgDate:data.judgDate,
						  judgResult:data.judgResult,
						  person:data.person,
						  publishDate:data.publishDate,
						  title:data.title,
								judeshowAll:false,
								personshowAll:false,
								};
								smlist.judeshowAll=data.judgResult.length<100;
								smlist.personshowAll=data.person.length<100;
							arrlist.push(smlist)  
						}
						
						this.judgmentDocNew=arrlist;
				}
					if(this.breakPromise.length>0){ 
						this.riskname[2].noempty=true;
				}else{
					this.riskText.push('暂无失信风险');
				}
					if(this.judicialCase.length>0){
						this.riskname[3].noempty=true;
				}
					if (this.limitExpense.length>0){  
						this.riskname[4].noempty=true;
				}else{
					this.riskText.push('暂无限制高消费风险');
				}
				
				for(var i=0;i<this.riskname.length;i++){
					if(this.riskname[i].noempty){
						this.risktype=this.riskname[i].type;
						break;
					}
				} 
				this.executeNum = this.isFree ? 3 : this.executedPerson.length;
				this.judgmentNum = this.isFree ? 3 : this.judgmentDoc.length;
				this.breakPromiseNum = this.isFree ? 3 : this.breakPromise.length;
				this.judicialCaseNum = this.isFree ? 3 : this.judicialCase.length;
				this.limitExpenseNum = this.isFree ? 3 : this.limitExpense.length;
				//   
				
			},
			mounted() {
				 // console.log(this.blockdata) ;
					 // executedPerson（被执行人）  judgmentDoc（裁判文书） breakPromise（失信信息） judicialCase（司法案件） limitExpense（限制高消费）
						// if(this.hasdata){
							// if(this.hasdata){
								// console.log('被执行人',this.blockdata);//有的时候不打印不出数据
								
							// }
							
							
						// }
					
					// console.log(_this.risktype,'_this.risktype',this.riskname)
			},
			methods:{
				 
			}
	}
</script>

<style> 
	.risktab{
		margin-bottom:30px;
	}
	.risktab .fl{
		margin-right: 30px;	border-bottom: 2px solid #fff;padding:0 10px ;cursor: pointer;
	}
	.risktab .fl:hover,.risktab .fl.current{
		border-bottom: 2px solid #5E83CC;
	}
</style>